/**
 * Storm Games shared Sentry init.
 *
 * One DSN, all 9 entry points (7 games + portal + lobby). Each game calls
 * initSentry() from its main.tsx; we tag every event with the gameSlug so
 * issues are filterable per game in the Sentry UI.
 */

import * as Sentry from '@sentry/react';

const DSN =
  'https://551dfab7f05ef55ce81ab20760e587e0@o4511291219312640.ingest.de.sentry.io/4511291222130768';

let initialised = false;

export function initSentry(gameSlug: string) {
  if (initialised) return;
  initialised = true;
  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.PROD ? 'production' : 'dev',
    tracesSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    replaysSessionSampleRate: 0,
    initialScope: { tags: { game: gameSlug } },
    beforeSend(event) {
      if (!import.meta.env.PROD) return null;
      return event;
    },
  });
}

export { Sentry };
